
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    startDate: {
      type: Object as PropType<Date>,
      required: false,
    },
  },
  setup(props) {
    const nowYear = new Date().getFullYear();
    const startYear =
      props.startDate &&
      props.startDate.getFullYear() !== nowYear &&
      props.startDate.getFullYear();

    return {
      copyrightDate: `${
        startYear ? startYear + '-' : ''
      }${new Date().getFullYear()}`,
    };
  },
});
